import React from "react";
import { Link } from "react-router-dom";

const UnderConstruction = () => (
  <div style={{
    display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
    height: "100vh", backgroundColor: "#fff3e0", textAlign: "center"
  }}>
    <span className="mb-40px" style={{ fontSize: "3rem" }}>🚧</span>
    <h1 className="mb-10px lh-1" style={{ fontSize: "2.5rem", color: "#e53935" }}>Page Under Construction</h1>
    <p style={{ color: "#555" }}>This page is not ready yet. Please come back soon.</p>
    <Link to='/' style={{
      marginTop: "20px", padding: "10px 20px", background: "#e53935",
      color: "white", textDecoration: "none", borderRadius: "8px"
    }}>Go to Home</Link>
  </div>
);

export default UnderConstruction;
